module.exports = __webpack_public_path__ + "files/106683838da984a2adee72b0471b53eb.png";